<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6.5 11.5" class="icon">
        <title>arrow</title>
        <polyline points="0.75 0.75 5.75 5.75 0.75 10.75" style="fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;transform-origin:center" v-bind:style="{transform: 'rotate(' + rotation + 'deg)', stroke: color}"/>
    </svg>
</template>

<script>
    export default {
        name: "IconArrow",

        props: {
            direction: {
                type: String,
                default: 'left',
                validator: value => ['up', 'down', 'left', 'right'].indexOf(value) !== -1
            },
            color: {
                type: String,
                default: '#231f20'
            }
        },

        computed: {
            rotation() {
                switch (this.direction) {
                    case 'left':
                        return 0;
                    case 'down':
                        return 90;
                    case 'right':
                        return 180;
                    case 'up':
                        return 270;
                }
            }
        }
    }
</script>